import { useMemo } from 'react';
import { useBindViewer } from '../../hooks/useBindViewer';
import { canAddChatMember, canDeleteChat, canRemoveChatMember, canRenameChat } from '../permissions';

export const useChatPermissions = () => {
  const bindViewer = useBindViewer();

  return useMemo(
    () => ({
      canAddChatMember: bindViewer(canAddChatMember),
      canDeleteChat: bindViewer(canDeleteChat),
      canRemoveChatMember: bindViewer(canRemoveChatMember),
      canRenameChat: bindViewer(canRenameChat),
    }),
    [bindViewer],
  );
};
